// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"559c4e83","239":"3fbf8700","453":"78eb1479","732":"30c3e184"}[chunkId] + ".chunk.js";
};